function _(n,t,o){var c=n(8),e={function:!0,object:!0};t.exports=function(n){return c(n)&&e[typeof n]||!1}}
//# sourceMappingURL=is-object.min.js.map